"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Text_1 = __importDefault(require("../Text"));
const FooterDT = ({ children }) => ((0, jsx_runtime_1.jsx)(Text_1.default, { fontSize: "sm", color: "white", fontWeight: "medium", italic: true, as: "dt", children: children }));
exports.default = FooterDT;
